function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React, { useState, useEffect } from 'react';
import PropTypes, { arrayOf, string, number, func, shape, oneOfType } from 'prop-types';
import './autocomplete.scss';

class Autocomplete extends React.PureComponent {
  constructor(props) {
    super(props);

    _defineProperty(this, "getDefaultName", () => (this.props.results.find(e => String(e.ineId) === String(this.props.defaultValue)) || {}).name || '');

    _defineProperty(this, "onChangeHandler", event => {
      this.setState({
        value: event.target.value
      });

      if (this.props.onChange) {
        this.props.onChange(event.target.value);
      }
    });

    _defineProperty(this, "onSelectHandler", select => {
      if (this.props.onSelect) {
        this.setState({
          value: select.name
        });
        this.props.onSelect(select);
      }
    });

    this.state = {
      value: this.props.defaultValue ? this.getDefaultName() : '',
      hasFocus: false
    };
  }

  componentDidUpdate(prevProps) {
    if (this.props.defaultValue !== prevProps.defaultValue) {
      this.setState({
        value: this.getDefaultName()
      });
    }
  }

  render() {
    const _this$props = this.props,
          results = _this$props.results,
          placeholder = _this$props.placeholder,
          showArrow = _this$props.showArrow;
    return React.createElement("div", {
      className: "autocomplete ".concat(showArrow && "showarrow", " ").concat(this.state.hasFocus ? "open" : ''),
      onClick: e => {
        if (e.target.nodeName !== 'INPUT') {
          this.setState({
            hasFocus: !this.state.hasFocus
          });
        }
      }
    }, React.createElement("input", {
      type: "text",
      autoComplete: "nope",
      value: this.state.value,
      onChange: e => this.onChangeHandler(e),
      onFocus: () => {
        this.setState({
          hasFocus: true
        });
      },
      onBlur: () => {
        setTimeout(() => this.setState({
          hasFocus: false
        }), 500);
      },
      placeholder: !this.state.hasFocus ? placeholder : ''
    }), React.createElement("ul", {
      className: this.state.hasFocus && results ? 'resultList open' : 'resultList'
    }, results.map((result, index) => React.createElement("li", {
      onClick: () => this.onSelectHandler(results[index]),
      key: result.ineId
    }, result.name))));
  }

}

Autocomplete.propTypes = {
  className: string,
  onChange: func,
  results: arrayOf(shape({
    ineId: oneOfType([string, number]),
    name: string
  }))
};
export default Autocomplete;